export const USER_ALLOWED_PATHS = ['/robots', '/reports', '/concierge-wayfinding'] as const;

export const USER_ALLOWED_PATH_SET = new Set<string>(USER_ALLOWED_PATHS);

export const isPathAllowedForUser = (pathname: string) =>
  USER_ALLOWED_PATHS.some(path => pathname === path || pathname.startsWith(`${path}/`));
